<div class="bg-white mb-5 py-3" *ngIf="showFilter">
  <div class="container-fluid">
    <div class="d-flex justify-content-between w-100">
      <strong class="pb-2 h5 d-block">Buscar por:</strong>

      <div class="align-self-center d-flex align-items-center">
        <ng-content select="[buttons]"></ng-content>
        <a *ngIf="registerButton" id="add-button" [routerLink]="pathRegister"
          class="btn rounded-pill btn-sm btn-outline-primary"
          [title]="customRegisterButton ?? 'Adicionar ' + options.title">
          {{ customRegisterButton ?? 'Adicionar' }}
        </a>
      </div>
    </div>

    <ng-content select="[filters]"></ng-content>

    <section class="row">
      <div class="col-12 col-md-12">
        <button type="submit" id="btn-buscar" (click)="submit()" title="Buscar" [disabled]="!canSubmit"
          class="btn rounded-pill btn-primary float-right ml-md-2 mb-2 col-md-auto">
          Buscar
        </button>
        <button id="btn-limpar" (click)="clearFilter()" id="clear-button" title="Limpar" type="submit"
          class="btn rounded-pill btn-outline-primary float-right ml-md-1 mb-2 col-md-auto">
          Limpar
        </button>
      </div>
    </section>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-red rounded-bottom-custom box-rounded-bottom rounded-0 mt-3">
    <div class="card-body border-top">
      <div class="row">
        <div class="col-12">
          <app-table-custom [items]="items" [itemsPerPage]="10" [paginatorCustom]="paginatorCustom" [page]="page"
            (changePage)="changePage($event)">
            <ng-template appTableHeader>
              <tr>
                <th *ngFor="let column of table.columns; let index = index" [id]="column + '-column'">
                  {{ column.title }}
                  <em *ngIf="column.orderTo" class="fas fa-sort" (click)="orderColumn(column.orderTo)"></em>
                </th>

                <th id="col-3" class="table-columns-acoes" *ngIf="showActions || table.customActions">
                  Ações
                </th>
                <th *ngIf="isCrud" id="col-4">
                  Em uso
                </th>
              </tr>
            </ng-template>
            <ng-template appTableBody let-item let-index>
              <tr (click)="lineClicked(item)">
                <ng-container *ngIf="!table.customColumns">
                  <td *ngFor="let column of table.columns" [class]="'text-' + (column.align || 'left')">
                    <ng-container *ngIf="column.showInTextarea; else elseTextarea">
                      <textarea cols="25" [value]="getValueColumn(item, column)" readonly></textarea>
                    </ng-container>
                    <ng-template #elseTextarea>
                      <ng-container *ngIf="!useInnerHtml; else useHtml">
                        {{ getValueColumn(item, column) }}
                      </ng-container>
                      <ng-template #useHtml>
                        <span [innerHTML]="getValueColumn(item, column)"></span>
                      </ng-template>
                    </ng-template>
                  </td>
                </ng-container>
                <ng-container *ngIf="table.customColumns">
                  <ng-container *ngTemplateOutlet="
                      customColumns;
                      context: { $implicit: item, index: index }
                    "></ng-container>
                </ng-container>

                <td class="table-columns-acoes" *ngIf="showActions">
                  <a *ngIf="botoesAcoesNovaAba && table.actions.view" [routerLink]="[pathView, item.id]" add-button=""
                    class="btn rounded-pill btn-default btn-sm mr-2" title="Visualizar">
                    <em class="fas fa-search"></em>
                  </a>
                  <button id="btn-visualizar" type="button" class="btn rounded-pill btn-default btn-sm mr-2"
                    title="Visualizar" (click)="view(item)" *ngIf="table.actions.view && !botoesAcoesNovaAba">
                    <em class="fas fa-search"></em>
                  </button>
                  <button id="btn-inativar-second" type="button" [title]="item.ativo ? 'Desativar' : 'Ativar'"
                    (click)="inactive(item)" class="btn rounded-pill btn-default btn-sm mr-2"
                    *ngIf="table.actions.inactive && inativeSecondPosition">
                      <em class="fas"
                      [ngClass]="definirCorIcone(item)"></em>
                  </button>
                  <a *ngIf="botoesAcoesNovaAba && table.actions.edit" [routerLink]="[pathEdit, item.id]" add-button=""
                    class="btn rounded-pill btn-default btn-sm mr-2" title="Editar">
                    <em class="fas fa-pencil-alt"></em>
                  </a>
                  <button id="btn-editar" type="button" class="btn rounded-pill btn-default btn-sm mr-2" title="Editar"
                    (click)="edit(item)" *ngIf="table.actions.edit && !botoesAcoesNovaAba">
                    <em class="fas fa-pencil-alt"></em>
                  </button>
                  <button id="btn-excluir" type="button" class="btn rounded-pill btn-default btn-sm" title="Excluir"
                    (click)="delete(item)" *ngIf="table.actions.delete">
                    <em class="fas fa-trash"></em>
                  </button>
                  <button id="btn-inativar" type="button" class="btn rounded-pill btn-default btn-sm mr-2"
                    [title]="item.ativo ? 'Desativar' : 'Ativar'" (click)="inactive(item)"
                    *ngIf="table.actions.inactive && !inativeSecondPosition">
                      <em class="fas"
                      [ngClass]="definirCorIcone(item)"></em>
                  </button>
                  <div class="form-check" *ngIf="table.actions.check">
                    <input id="checkbox" class="form-check-input" type="checkbox"
                      (click)="check(item, $event.target.checked)" />
                  </div>
                </td>

                <td *ngIf="isCrud" class="text-center">
                  <button *ngIf="item.tabelasRelacionadas?.length" (click)="exibirTabelasRelacionadas(item)"
                    class="btn rounded-pill btn-default btn-sm" title="Em uso" id="btn-em-uso" type="button">
                    <em class="fas fa-check-circle text-primary">
                    </em>
                  </button>
                </td>

              </tr>
            </ng-template>
            <ng-template appTableEmpty>
              <tr>
                <td [attr.colspan]="'100%'" class="text-center">
                  {{ emptyMessage }}
                </td>
              </tr>
            </ng-template>
          </app-table-custom>
        </div>
      </div>
    </div>
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
